module.exports = __webpack_public_path__ + "images/business-class-logo-white@2x.5ccffc76fe9c9220a251.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/business-class-logo-white@2x.png
// module id = pSLv
// module chunks = 0